import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

interface IHeadingProps {
  developerUrl?: string;
  developerName: string;
}

export const Heading: React.FC<IHeadingProps> = ({ developerUrl, developerName }) => {
  return (
    <UIHeading1 as="h1">
      Купить квартиру от застройщика{' '}
      <a href={developerUrl} target="_blank" rel="noreferrer" className={style['link']}>
        {developerName}
      </a>
    </UIHeading1>
  );
};
